import styled from 'styled-components';

export const AddCashMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    border-radius: 1rem;
    box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
    background-color: ${props.theme.colors.white.base};
    padding: ${props.theme.spacing.large.l16};
    margin-bottom: ${props.theme.spacing.large.l15};
    @media (max-width: 768px) {
      border-radius: 0;
    }
  `,
);

export const AddCashInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
  `,
);

export const AddCashHeadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
);

export const AddCashHeadTextWrap = styled.div(
  props => `
    width:40%;
    display: flex;
  `,
);

export const AddCashIconWrap = styled.div(
  props => `
    width:3.5rem;
    margin-right: ${props.theme.spacing.small.s6};
    @media (max-width: 768px) {
      display: none;
    }
  `,
);

export const AedText = styled.span(
  props => `
    width: '1.4rem'; 
    height: '1.4rem';
  `,
);

export const AddCashText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font22};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    @media (max-width: 768px) {
      font-size: ${props.theme.font.large.font16};
    }
  `,
);

export const AddCashHeadInfoWrap = styled.div(
  props => `
    width:60%;
    display: flex;
    align-items:center;
    align-self: center;
  `,
);

export const AddCashInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.blue.dark3b};
    display: flex;
    align-items: center;
  `,
);

export const RechargeInfoWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l16};
    cursor: ${props.disabled ? '' : 'pointer'};
    pointer-events: ${props.disabled ? 'none' : ''};
    opacity: ${props.disabled ? '0.4' : '1'};
    background-color: #f8f8f8;
    margin-top: ${props.theme.spacing.large.l20};
  `,
);

export const RechargeInfoHeadLabel = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.grey.base};
    padding-bottom: ${props.theme.spacing.large.l16};
  `,
);

export const RechargeInfoLabel = styled.label(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
  `,
);

export const ReachargeErrorText = styled.label(
  props => `
    font-size: ${props.theme.font.large.font12};
    color: ${props.theme.colors.red.base};
  `,
);

export const ReachargeInput = styled.input(
  props => `
    width:40%;
    display: flex;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid ${props.theme.colors.grey.base1};
    padding: ${props.theme.spacing.small.s7} 0;
    font-size: ${props.theme.font.large.font22};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    outline: none;
    background-color: #f8f8f8;
  `,
);

export const RechargeOptionWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    padding:0 ${props.theme.spacing.large.l16} ${props.theme.spacing.large.l16};
    @media (max-width: 768px) {
      flex-direction: column;
    }
  `,
);

export const RechargeIncentiveText = styled.p(
  props => `
    font-size: 18px;
    color: #1a7971;
    font-weight: 800;
  `,
);

export const ReachargeOptionWrap = styled.div(
  props => `
    width:70%;
    display: flex;
    align-items: center;
    padding-bottom: ${props.theme.spacing.base};
    @media (max-width: 768px) {
      width: 100%;
    }
  `,
);

export const ReachargeOptionTag = styled.div(
  props => `
    display: flex;
    align-self: flex-start;
    margin-right: ${props.theme.spacing.base};
    padding:${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    align-items: center;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    border: 1px solid transparent;
    cursor: ${props.disabled ? '' : 'pointer'};
    pointer-events: ${props.disabled ? 'none' : ''};
    opacity: ${props.disabled ? '0.4' : '1'};
    background-color: ${props.theme.colors.white.base};
    @media (max-width: 768px) {
      margin-right: ${props.theme.spacing.small.s5};
      padding:${props.theme.spacing.small.s5} ${props.theme.spacing.base};
    }
  `,
);

export const ReachargeOptionActiveTag = styled.div(
  props => `
    display: flex;
    align-self: flex-start;
    margin-right: ${props.theme.spacing.base};
    padding:${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    align-items: center;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    border: 1px solid ${props.theme.colors.blue.base};
    @media (max-width: 768px) {
      margin-right: ${props.theme.spacing.small.s5};
      padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
    }
  `,
);

export const OptionText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    @media (max-width: 768px) {
      font-size: ${props.theme.font.base};
    }
  `,
);

export const OptionActiveText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const ReachargeButtonWrap = styled.div(
  props => `
    width:30%;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 768px) {
      width:100%;
    }
  `,
);

export const RechargeButton = styled.button(
  props => `
    display: flex;
    outline: none;
    border: none;
    cursor: pointer;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l60};
    border-radius: 3.4rem;
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(93deg, #53b2fe 0%, #065af3 130%);
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    pointer-events: ${props.disabled ? 'none' : ''};
    text-transform: uppercase;
    @media (max-width: 768px) {
      width:100%;
      text-align: center;
      margin-top: ${props.theme.spacing.base};
      justify-content: center;
    }
  `,
);

export const RechargeButtonDisabled = styled.button(
  props => `
    display: flex;
    outline: none;
    border: none;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l60};
    border-radius: 3.4rem;
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
    background-color: ${props.theme.colors.grey.base};
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    text-transform: uppercase;
  `,
);

export const NeftRechargeBlock = styled.div(
  props => `
    display: flex;
    position: relative;
    background-color: #f1f6fd;
    padding: ${props.theme.spacing.large.l16};
    width:100%;
    margin: ${props.theme.spacing.large.l20} 0;
    border:1px solid #e7f0ff;
  `,
);

export const RecommendedTag = styled.div(
  props => `
    position: absolute;
    top: -11px;
    left: 1.6rem;
    z-index:2;
    background-image: linear-gradient(to right, #c86dd7, #3023ae);
    padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.base};
    border-radius: 1.5rem;
  `,
);

export const RecommendedText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.white.base};
    text-transform: uppercase;
  `,
);

export const NeftInnerBlock = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  `,
);

export const NeftInfoWrap = styled.div(
  props => `
    width:70%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 768px) {
      width:100%;
    }
  `,
);

export const NeftHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.grey.base};
    display: flex;
    align-items: center;
  `,
);

export const NewTagNeft = styled.span(
  props => `
    font-size: ${props.theme.font.small.font10};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};
    background-image: linear-gradient(to right, #43e1a8, #219393);
    padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5} ${props.theme.spacing.small.s2};
    margin-left: ${props.theme.spacing.small.s5};
    border-radius: 1.5rem;
    text-transform: uppercase;
  `,
);

export const NeftInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    padding-top: ${props.theme.spacing.small.s4};
  `,
);

export const NoteText = styled.p(
  props => `
    font-size: 15px;
  `,
);

export const NeftDetailBtnWrap = styled.div(
  props => `
    width:30%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    @media (max-width: 768px) {
      width:100%;
      margin-top: ${props.theme.spacing.base};
      justify-content: flex-start;
    }
  `,
);

export const NeftDetailBtn = styled.a(
  props => `
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.blue.base};
    cursor: pointer;
  `,
);

export const OptionalBlock = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);

export const OptionalText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.black.base};
  `,
);

export const AddCashDisabledBlock = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.base} 0;
    flex-direction: column;
  `,
);

export const DisabledText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.red.base};
  `,
);

export const AddCashBlockOuter = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
  `,
);
